import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import i18nBackend from 'i18next-http-backend';

const getQueryParam = (name: string) => {
  const urlSearchParams = new URLSearchParams(window.location.search);

  return urlSearchParams.get(name);
};

const languageFromQueryParam = getQueryParam('lang') || 'en';

const getCurrentHost = import.meta.env.VITE_HOST_URL;

i18n
  .use(i18nBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    lng: languageFromQueryParam,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: `${getCurrentHost}/i18n/{{lng}}.json`,
    },
  });

export { default } from 'i18next';
